import { render, staticRenderFns } from "./PatientByIdFinder.vue?vue&type=template&id=0a2b8a12&scoped=true&"
import script from "./PatientByIdFinder.vue?vue&type=script&lang=ts&"
export * from "./PatientByIdFinder.vue?vue&type=script&lang=ts&"
import style0 from "./PatientByIdFinder.vue?vue&type=style&index=0&id=0a2b8a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b8a12",
  null
  
)

export default component.exports